"use client";

import { useMediaQuery } from "@mantine/hooks";
import { FC, useState } from "react";
import LoadingText from "./LoadingText";

type LoadingAnimationTextProps = {
    loadingText: string | string[];
    animateText: boolean;
};

const LoadingAnimationText: FC<LoadingAnimationTextProps> = ({
    loadingText,
    animateText,
}) => {
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    const prefersReducedMotion = useMediaQuery(
        "(prefers-reduced-motion: reduce)",
    );

    if (!loadingText) {
        return null;
    }

    const isArray = Array.isArray(loadingText);

    if (!isArray || loadingText.length === 1) {
        return <span>{loadingText}</span>;
    }

    if (!animateText || prefersReducedMotion) {
        const textNode = loadingText.map((text) => {
            return <span key={text}>{text}</span>;
        });

        return <>{textNode}</>;
    }

    return (
        <>
            <LoadingText
                afterFadeOut={() => {
                    if (currentTextIndex === loadingText.length - 1) {
                        setCurrentTextIndex(0);
                    } else {
                        setCurrentTextIndex(currentTextIndex + 1);
                    }
                }}
            >
                {loadingText[currentTextIndex]}
            </LoadingText>
            <span className="visually-hidden">{loadingText.join()}</span>
        </>
    );
};
export default LoadingAnimationText;
